import { render } from "./StandardHero.vue?vue&type=template&id=33474b4c&scoped=true"
import script from "./StandardHero.vue?vue&type=script&lang=js"
export * from "./StandardHero.vue?vue&type=script&lang=js"

import "./StandardHero.vue?vue&type=style&index=0&id=33474b4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33474b4c"]])

export default __exports__